import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from 'axiosConfig';
import { queryClient } from "App";
import { Toast } from "components"; 
import { TOAST_TYPES_ENUM } from 'enums'; 
import { setOfflineAuth } from '../useOfflineAuth';

const loginBySms = async (credentials: any): Promise<any> => {
  const {data} = await axiosInstance.post(`/auth/login/sms`, credentials);
  return data;
};

export const useLoginBySms = (
  options?: UseMutationOptions<any, Error, any>
) => {
  return useMutation({
    mutationKey: ["login"],
    ...options,
    mutationFn: async (credentials: any) => {
      return loginBySms(credentials);
    },
    onMutate: (variables) => {
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Logowanie...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "login",
      });
      Toast({
        message: "Zalogowano pomyślnie",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "login",
      });
      
      if (data.token) {
        setOfflineAuth({
          token: data.token,
          expiresIn: data.expiresAT
        });
      }
      
      queryClient.prefetchQuery({ queryKey: ["me"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd logowania",
        type: TOAST_TYPES_ENUM.HIDE,
        id: "login",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
